import React from "react";

function DrawButton(props) {
    const buttonStyle = {
        opacity: "0.8",
        backgroundColor: props.isActive ? "#dc3545" : "transparent", // Red background when active
        color: props.isActive ? "white" : "#dc3545", // White text/icon when active, red when not
    };

    return (
        <button type="button" className="btn btn-outline-danger btn-sm photoEditorButton" style={buttonStyle} onClick={props.onClick} value={props.value}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-pencil-fill" viewBox="0 0 16 16">
                <path fill={props.isActive ? "white" : "#dc3545"} d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
            </svg>
        </button>
    );
}

export default DrawButton;